import {
  AiOutlineInstagram,
  AiOutlineTwitter,
  AiOutlineDribbble,
  AiFillGithub,
} from "react-icons/ai";

const data = [
  { id: 4, link: "https://github.com/AnishMachamasi", icon: <AiFillGithub /> },
  { id: 1, link: "https://instagram.com", icon: <AiOutlineInstagram /> },
  { id: 2, link: "https://twitter.com", icon: <AiOutlineTwitter /> },
  { id: 3, link: "https://dribble.com", icon: <AiOutlineDribbble /> },
];

export default data;
